function Rating({ rating, setRating, size }) {
  return (
    <div>
      {[1, 2, 3, 4, 5].map((star, index) => {
        const isFullStar = rating >= star; // Fully filled star logic
        const isHalfStar =
          rating > star - 1 && // Current star is partially filled
          rating < star && // Not fully filled
          Math.floor(rating) + 0.3 <= rating; // Fractional part >= 0.3

        return (
          <span
            key={index}
            className="star"
            style={{
              display: 'inline-block',
              cursor: 'pointer',
              fontSize: size ? `${size}px` : '14px',
              position: 'relative',
              color: isFullStar ? '#D78B30' : 'gray', // Full star color
            }}
            onClick={() => setRating(star)}
          >
            {isFullStar ? (
              '★' // Fully filled star
            ) : isHalfStar ? (
              <span style={{ position: 'relative', display: 'inline-block' }}>
                <span
                  style={{
                    color: '#D78B30',
                    width: '50%',
                    overflow: 'hidden',
                    position: 'absolute',
                    display: 'inline-block',
                  }}
                >
                  ★
                </span>
                <span style={{ color: 'gray' }}>★</span>
              </span>
            ) : (
              '★' // Empty star
            )}
          </span>
        );
      })}
    </div>
  );
}


export default Rating;
